import { Card } from '@codes/ui-kit/components/ui/card';

import { Skeleton } from '@codes/ui-kit';

export const ProjectCardSkeleton = () => {
    return (
        <Card className="h-[360px] flex flex-col border border-gray-200 p-5">
            <Skeleton className="h-[140px] w-full rounded-lg" />
            <div className="mt-4 space-y-2">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
            </div>
            <div className="flex gap-2 mt-3">
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-6 w-20" />
                <Skeleton className="h-6 w-18" />
            </div>
            <div className="mt-auto flex gap-2 pt-4">
                <Skeleton className="h-9 flex-1" />
                <Skeleton className="h-9 w-9" />
            </div>
        </Card>
    );
};
